import React, { useEffect, useState } from "react";
import { Loader2, CheckCircle2, AlertTriangle, XCircle } from "lucide-react";
import api from "@/lib/api";

// Pre-flight reference quality check (Phase 3). Pass a data-url image.
export default function ReferenceQuality({ image, onResult, testid = "ref-quality" }) {
  const [loading, setLoading] = useState(false);
  const [res, setRes] = useState(null);

  useEffect(() => {
    if (!image) { setRes(null); return; }
    let alive = true;
    setLoading(true);
    api.post("/ai/reference-check", { image })
      .then(({ data }) => { if (alive) { setRes(data); onResult && onResult(data); } })
      .catch(() => { if (alive) setRes(null); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [image]);

  if (!image) return null;
  if (loading) return (
    <div className="flex items-center gap-2 mt-2 font-mono-tech text-[10px] text-white/40" data-testid={`${testid}-loading`}>
      <Loader2 size={12} className="animate-spin" /> Analyzing reference…
    </div>
  );
  if (!res) return null;

  const color = res.quality === "good" ? "#39ff14" : res.quality === "poor" ? "#ff007f" : "#eaff00";
  const Icon = res.quality === "good" ? CheckCircle2 : res.quality === "poor" ? XCircle : AlertTriangle;
  return (
    <div className="mt-2 space-y-1.5" data-testid={testid}>
      <div className="flex items-center gap-2 font-mono-tech text-[10px] uppercase tracking-widest" style={{ color }}>
        <Icon size={12} /> Reference quality: {res.quality} {res.faces > 1 && `· ${res.faces} faces`}
      </div>
      {res.warnings?.map((w) => (
        <div key={w.code} className="flex items-start gap-1.5 font-mono-tech text-[10px]"
          style={{ color: w.severity === "error" ? "#ff007f" : "rgba(255,255,255,0.45)" }} data-testid={`${testid}-warn-${w.code}`}>
          <AlertTriangle size={11} className="shrink-0 mt-0.5" /> {w.label}
        </div>
      ))}
    </div>
  );
}
